export const QUESTIONS = [
    { id: 1, text: 'Pinterestはユーザーが暇つぶしにピンを流し見出来ることが最大の魅力のサービスである(YES/NO)', answer: 'NO' },
    { id: 2, text: 'Pinterest が「多くの人が好きなもの」ではなく「一人一人のユーザーが好きなもの」を理解しようと注力している(YES/NO)', answer: 'YES' },
    { id: 3, text: 'Pinterestの4つの強みは 1. パーソナルな発見ツール 2. 成果につながるポジティブな環境 3. 計画好きなユーザー 4.◯◯◯◯が高いユーザーです。◯◯◯◯に当てはまるワードを書いてください。', answer: '購買意欲' },
    { id: 4, text: 'Pinterestの4つの強みは 1. ◯◯◯◯◯な発見ツール 2. 成果につながるポジティブな環境 3. 計画好きなユーザー 4.購買意欲が高いユーザーです。◯◯◯◯◯に当てはまるワードを書いてください。', answer: 'パーソナル' },
    { id: 5, text: 'Pinterestの4つの強みは 1. パーソナルな発見ツール 2. ◯◯につながるポジティブな環境 3. 計画好きなユーザー 4.購買意欲が高いユーザーです。◯◯に当てはまるワードを書いてください。', answer: '成果' },
    { id: 6, text: 'Pinterestの4つの強みは 1. パーソナルな発見ツール 2. 成果につながるポジティブな環境 3. ◯◯好きなユーザー 4.購買意欲が高いユーザーです。◯◯に当てはまるワードを書いてください。', answer: '計画' },
    {id: 7, text: 'Pinterest では有害な誤情報や政治活動広告の禁止されている(YES/NO)', answer:"YES"},
    {id: 8, text: 'Pinterest では有害な誤情報は禁止されているが、政治活動広告の禁止されていない(YES/NO)', answer:"NO"},
    {id: 9, text: 'Pinterest はメンタルヘルスをサポートする機能を提供している(YES/NO)', answer:"YES"},
    {id: 10, text: 'Pinterest の調査によると、ユーザーは、ネガティブなコンテンツの隣にブランド広告が表示されていた場合、ブランドがそのコンテンツを支持していると見なすと回答している(YES/NO)', answer: "YES"},
    {id: 11, text: 'Pinterest の調査によると、ユーザーは、ネガティブなコンテンツの隣にブランド広告が表示されていたとしても、ブランドがそのコンテンツを支持しているとは考えない(YES/NO)', answer: "NO"},
    {id: 12, text: 'Pinterest を使っているユーザーは殆どの場合、何を買うか具体的に決めてサービスを使っているわけではない(YES/NO)', answer: "YES"},
    {id: 13, text: 'Pinterest おける広告はユーザー体験を高める存在であり、煩わしい存在ではない(YES/NO)', answer: "YES"},
    {id: 14, text: 'Pinterest のユーザーの多くは「何かを購入するため」にサービスを利用している(YES/NO)', answer: "YES"},
    {id: 15, text: 'Pinterest の調査によれば、他のソーシャルプラットフォームのユーザーに比べて、Pinterest でのひと月あたりの購入金額は 40%以上 多くなっています(YES/NO)', answer: "YES"},
    {id: 16, text: 'Pinterest の調査によれば、他のソーシャルプラットフォームのユーザーに比べて、Pinterest でのひと月あたりの購入金額は 200% 多くなっています(YES/NO)', answer: "NO"}];



/** WEBPACK FOOTER **
 ** ./src/Questions.js
 **/